export const generateRandomId = (length: number) => {
  let result = "";
  const characters =
    "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
  const charactersLength = characters.length;
  let counter = 0;
  while (counter < length) {
    result += characters.charAt(Math.floor(Math.random() * charactersLength));
    counter += 1;
  }
  return result.toString();
};

export const getAgeFromDateOfBirth = (dateOfBirth: any) => {
  const today = new Date();
  let thisYear = 0,
    age = 0;

  if (today.getMonth() < dateOfBirth.getMonth()) {
    thisYear = 1;
  } else if (
    today.getMonth() === dateOfBirth.getMonth() &&
    today.getDate() < dateOfBirth.getDate()
  ) {
    thisYear = 1;
  }
  age = today.getFullYear() - dateOfBirth.getFullYear() - thisYear;

  return age;
};
